module.exports = __webpack_public_path__ + "685285309a3aba61d764826e2722c151.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-20.png
// module id = 2461
// module chunks = 0